import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable()
export class SessionHttpInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.method === 'GET' && environment.production) {
			req = req.clone({
				headers: req.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache')
			});
		}
		if (environment.production) {
			return next.handle(req);
		}

		// This allows for cookies/sessions to be kept over multiple domains.
		req = req.clone({
			withCredentials: true
		});
		return next.handle(req);
	}
}
